// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__WjAUg","hand":"Home_hand__ICaP8","wave":"Home_wave__plV8a"};